export const OBSERVER_ENTRY_URL = 'meekijken';
